import { Container, Stack, Text, Title } from '@mantine/core';

import config from '@/config';

export const Terms = () => {
  const { product, legalEntity, email } = config.brand;

  return (
    <Container py="xl">
      <Stack>
        <Title>End User License Agreement</Title>
        <Title order={2}>1. Definitions</Title>
        <Text>
          This End User License Agreement (referred to as the “EULA”) is an agreement between{' '}
          {legalEntity} and all users for the non-exclusive right to use {product} (hereinafter
          referred to as the “Service” or “Product”) in accordance with the features described
          below.
        </Text>
        <Title order={2}>2. CONTENT OF THE END USER LICENSE AGREEMENT</Title>
        <Text>2.1. This EULA should be viewed as a License Agreement (non-exclusive)</Text>
        <Text>2.2. Users acknowledge this EULA upon registering.</Text>
        <Text>
          2.3. Access to {product} functionality is provided "as is" and as posted online. The
          Licensor does not offer any warranties or assurances regarding access to {product}.
        </Text>
        <Text>
          2.4. The license for the right to use {product} is granted when the User signs in for the
          first time on the platform.
        </Text>
        <Text>
          2.5. This EULA can be terminated by the User by sending a request to the address or email
          specified in Section 8 of this EULA.
        </Text>
        <Text>
          2.6. This EULA ends after 14 business days from when we receive a termination notice.
        </Text>
        <Title order={2}>3. Features</Title>
        <Text>
          3.1. Users are given permission to utilize {product} for business purposes exclusively.{' '}
          {product} is not designed for personal or household use unrelated to business activities.
          Each user is responsible for ensuring the proper handling of personal data in compliance
          with current laws and our approved personal data processing policy, along with other
          applicable local regulations.
        </Text>
        <Text>
          3.2. The Licensor neither initiates nor controls any information placed by the User while
          using {product}, nor does it influence its content or integrity. The Licensor cannot
          ascertain whether such information violates the legally protected rights and interests of
          third parties, international treaties, or legislation.
        </Text>
        <Text>
          3.3. The Licensor bears no responsibility to users or any third parties for any indirect,
          incidental, or unintentional damages, including actual damages, lost profits, or lost
          data, as well as damages to reputation, dignity, or business standing resulting from the
          use of {product}.
        </Text>
        <Title order={2}>4. Licensor rights and responsibilities</Title>
        <Title order={4}>4.1. Responsibilities</Title>
        <Text>4.1.1. Offer technical assistance to Users</Text>
        <Title order={4}>4.2. Rights</Title>
        <Text>
          4.2.1. Modify the terms of this User Agreement without mandatory notification to Users.
        </Text>
        <Title order={2}>5. Users rights and responsibilities</Title>
        <Title order={4}>5.1. Responsibilities</Title>
        <Text>
          5.1.1 Promptly inform the Licensor of any unauthorized attempts to access the User's
          personal account by third parties.
        </Text>
        <Text>
          5.1.2. Use the Program in good faith, adhering to the restrictions outlined in this
          Agreement, and in compliance with legal requirements for safeguarding confidential
          information, including personal data.
        </Text>
        <Text>5.1.3. Refrain from interfering with or altering the {product} code.</Text>
        <Title order={4}>5.2. Rights</Title>
        <Text>
          5.2.1 Utilize the functions of the Program within the confines specified by this
          Agreement.
        </Text>
        <Text>
          5.2.2. Reach out to the Licensor for inquiries regarding the Service, its technical
          capabilities, troubleshooting, and related matters.
        </Text>
        <Title order={2}>6. Resolving disagreements</Title>
        <Text>{email}</Text>
      </Stack>
    </Container>
  );
};
